module.exports = __webpack_public_path__ + "static/waye-talks-logo-white-large-8846409fa81a38cac780e89d68a8a108.png";